(() => {
  function init() {
    document.querySelectorAll('[data-asap-recovery-compare]').forEach(root => {
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      const inputs=Array.from(root.querySelectorAll('[data-asap-choose]'));
      const cards=Array.from(root.querySelectorAll('[data-asap-model]'));
      const requested=(new URLSearchParams(location.search).get('products')||'').split(',');
      const valid=inputs.map(i=>i.value);
      let selected=[...new Set(requested)].filter(h=>valid.includes(h)).slice(0,3);
      if(!selected.length)selected=valid.slice(0,3);
      function render(){
        inputs.forEach(i=>{i.checked=selected.includes(i.value);i.disabled=!i.checked&&selected.length>=3;});
        cards.forEach(c=>c.hidden=!selected.includes(c.dataset.asapModel));
        root.querySelector('[data-asap-compare-status]').textContent=`${selected.length} of 3 models selected`;
      }
      root.addEventListener('change',event=>{
        if(!inputs.includes(event.target))return;
        selected=inputs.filter(i=>i.checked).map(i=>i.value).slice(0,3);
        const url=new URL(location.href);url.searchParams.set('products',selected.join(','));history.replaceState(null,'',url);render();
      });render();
    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();
